import {
  AppPublicLayout,
  AppPublicPage,
  PublicDocument,
} from "./../layout";

export function Agb() {
  return (
    <AppPublicLayout>
      <AppPublicPage width="narrow">
        <PublicDocument>
          <h1>Allgemeine Geschäftsbedingungen (AGB) für Logami</h1>

          <p className="lead">
            Version 1.0
          </p>

          <h2>1. Anbieter</h2>
          <p>Anbieter der Software „Logami“ ist:</p>
          <address>
            Lukas Ottweiler
            <br />
            Logami
            <br />
            c/o MDC#986
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Deutschland
            <br />
            E-Mail: <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </address>
          <p>(nachfolgend „Logami“)</p>

          <h2>2. Geltungsbereich</h2>
          <p>
            Diese AGB gelten für alle Verträge über die Nutzung der
            Software-as-a-Service-Plattform (SaaS) „Logami“ zwischen Logami und
            seinen Kunden.
          </p>
          <p>
            Das Angebot richtet sich ausschließlich an Unternehmer im Sinne von
            § 14 BGB. Verbraucher sind von der Nutzung ausgeschlossen.
          </p>
          <p>
            Mit Abschluss eines Vertrags bestätigt der Kunde, dass er als
            Unternehmer handelt.
          </p>

          <h2>3. Vertragsgegenstand</h2>
          <p>
            Logami stellt eine cloudbasierte Software zur Verfügung, die
            Unternehmen bei der Planung, Durchführung und Dokumentation von
            Aufträgen unterstützt.
          </p>
          <p>Zu den Funktionen können insbesondere gehören:</p>
          <ul>
            <li>Verwaltung von Kunden und Ansprechpartnern</li>
            <li>Verwaltung von Mitarbeitern</li>
            <li>Erstellung und Verwaltung von Aufträgen</li>
            <li>Erfassung von Arbeitszeiten</li>
            <li>Erfassung von GPS-Standorten</li>
            <li>Dokumentation durch Fotos, Notizen und Unterschriften</li>
            <li>Auswertungen und Datenexporte</li>
          </ul>
          <p>
            Der genaue Funktionsumfang ergibt sich aus der jeweils aktuellen
            Produktbeschreibung.
          </p>
          <p>
            Logami ist berechtigt, die Software weiterzuentwickeln und
            Funktionen zu verbessern, sofern dadurch der vertragsgemäße Nutzen
            für den Kunden nicht wesentlich eingeschränkt wird.
          </p>

          <h2>4. Registrierung und Kundenkonto</h2>
          <p>
            Für die Nutzung ist die Erstellung eines Kundenkontos erforderlich.
          </p>
          <p>
            Der Kunde benennt mindestens einen Administrator. Dieser ist
            berechtigt, weitere Nutzer einzuladen und Berechtigungen zu
            verwalten.
          </p>
          <p>
            Der Kunde ist dafür verantwortlich, dass die im Kundenkonto
            hinterlegten Informationen aktuell und korrekt sind.
          </p>
          <p>
            Zugangsdaten sind vertraulich zu behandeln und vor dem Zugriff
            Dritter zu schützen.
          </p>

          <h2>5. Nutzer und Verantwortlichkeit</h2>
          <p>
            Der Kunde ist für alle Nutzer verantwortlich, die seinem Kundenkonto
            zugeordnet sind.
          </p>
          <p>
            Der Kunde stellt sicher, dass seine Nutzer die Software nur im
            Rahmen der geltenden Gesetze sowie der Nutzungsbedingungen
            verwenden.
          </p>
          <p>
            Handlungen von eingeladenen Nutzern werden dem Kunden zugerechnet.
          </p>

          <h2>6. Kundendaten</h2>
          <p>
            Alle vom Kunden oder dessen Nutzern erfassten Daten bleiben Eigentum
            des Kunden.
          </p>
          <p>Hierzu gehören insbesondere:</p>
          <ul>
            <li>Kundendaten</li>
            <li>Mitarbeiterdaten</li>
            <li>Auftragsdaten</li>
            <li>Adressen</li>
            <li>GPS-Daten</li>
            <li>Fotos</li>
            <li>Notizen</li>
            <li>Unterschriften</li>
          </ul>
          <p>
            Der Kunde ist dafür verantwortlich, dass die Verarbeitung dieser
            Daten rechtmäßig erfolgt.
          </p>
          <p>
            Insbesondere obliegt es dem Kunden, notwendige arbeitsrechtliche,
            datenschutzrechtliche oder sonstige gesetzliche Anforderungen
            gegenüber seinen Mitarbeitern und Endkunden einzuhalten.
          </p>

          <h2>7. Verfügbarkeit</h2>
          <p>Logami bemüht sich um eine hohe Verfügbarkeit der Dienste.</p>
          <p>
            Vorübergehende Einschränkungen können insbesondere entstehen durch:
          </p>
          <ul>
            <li>Wartungsarbeiten</li>
            <li>Sicherheitsupdates</li>
            <li>technische Störungen</li>
            <li>Ereignisse außerhalb des Einflussbereichs von Logami</li>
          </ul>
          <p>
            Ein Anspruch auf eine bestimmte Verfügbarkeit besteht nur, sofern
            ausdrücklich schriftlich vereinbart.
          </p>

          <h2>8. Preise und Zahlung</h2>
          <p>
            Die Nutzung erfolgt auf Basis der jeweils zum Zeitpunkt des
            Vertragsschlusses veröffentlichten Preise.
          </p>
          <p>
            Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer.
          </p>
          <p>Die Abrechnung erfolgt monatlich.</p>
          <p>
            Zahlungen werden über den eingesetzten Zahlungsdienstleister
            abgewickelt.
          </p>

          <h2>9. Geld-zurück-Garantie</h2>
          <p>
            Neue Kunden können innerhalb von 30 Tagen nach erstmaligem
            Vertragsabschluss eine vollständige Rückerstattung verlangen.
          </p>
          <p>
            Nach Ablauf dieser Frist besteht kein Anspruch auf Rückerstattung
            bereits gezahlter Entgelte.
          </p>
          <p>Gesetzliche Ansprüche bleiben unberührt.</p>

          <h2>10. Laufzeit und Kündigung</h2>
          <p>Der Vertrag wird auf unbestimmte Zeit geschlossen.</p>
          <p>
            Der Kunde kann den Vertrag jederzeit zum Ende des aktuellen
            Abrechnungszeitraums kündigen.
          </p>
          <p>
            Logami kann den Vertrag mit einer Frist von 30 Tagen zum Ende des
            aktuellen Abrechnungszeitraums kündigen.
          </p>
          <p>
            Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt
            unberührt.
          </p>

          <h2>11. Datenexport und Löschung</h2>
          <p>
            Der Kunde kann seine Daten vor Vertragsende exportieren, soweit
            entsprechende Exportfunktionen bereitgestellt werden.
          </p>
          <p>
            Nach Vertragsbeendigung wird Logami die Kundendaten nach Ablauf
            gesetzlicher Aufbewahrungspflichten löschen.
          </p>
          <p>
            Logami ist berechtigt, Kundendaten nach Vertragsende und Ablauf
            einer angemessenen Übergangsfrist dauerhaft zu entfernen.
          </p>

          <h2>12. Geistiges Eigentum</h2>
          <p>
            Alle Rechte an der Software, der Benutzeroberfläche, dem Quellcode,
            Marken, Logos und sonstigen Bestandteilen von Logami verbleiben bei
            Logami.
          </p>
          <p>
            Der Kunde erhält ein einfaches, nicht übertragbares Recht zur Nutzung
            der Software im Rahmen des Vertrags.
          </p>

          <h2>13. Verbotene Nutzung</h2>
          <p>Es ist insbesondere untersagt,</p>
          <ul>
            <li>Schadsoftware zu verbreiten,</li>
            <li>Sicherheitsmechanismen zu umgehen,</li>
            <li>die Software missbräuchlich zu verwenden,</li>
            <li>Rechte Dritter zu verletzen,</li>
            <li>rechtswidrige Inhalte zu speichern oder zu verbreiten.</li>
          </ul>
          <p>
            Logami ist berechtigt, bei schwerwiegenden Verstößen den Zugang
            vorübergehend zu sperren.
          </p>

          <h2>14. Haftung</h2>
          <p>Logami haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit.</p>
          <p>
            Bei leichter Fahrlässigkeit haftet Logami nur bei Verletzung
            wesentlicher Vertragspflichten. In diesem Fall ist die Haftung auf
            den vorhersehbaren, vertragstypischen Schaden begrenzt.
          </p>
          <p>
            Die Haftung nach zwingenden gesetzlichen Vorschriften bleibt
            unberührt.
          </p>
          <p>
            Der Kunde ist für die regelmäßige Sicherung seiner exportierten Daten
            verantwortlich.
          </p>
          <p>
            Logami schuldet keine rechtliche, steuerliche oder arbeitsrechtliche
            Beratung.
          </p>

          <h2>15. Datenschutz</h2>
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt gemäß den
            Datenschutzhinweisen von Logami.
          </p>
          <p>
            Soweit Logami personenbezogene Daten im Auftrag des Kunden
            verarbeitet, gilt zusätzlich der Auftragsverarbeitungsvertrag (AVV).
          </p>

          <h2>16. Änderungen dieser AGB</h2>
          <p>
            Logami kann diese AGB mit Wirkung für die Zukunft ändern, soweit
            hierfür ein sachlicher Grund besteht und der Kunde hierdurch nicht
            unangemessen benachteiligt wird.
          </p>
          <p>Über wesentliche Änderungen wird der Kunde rechtzeitig informiert.</p>

          <h2>17. Schlussbestimmungen</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
            UN-Kaufrechts.
          </p>
          <p>
            Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts
            oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand der
            Sitz von Logami.
          </p>
          <p>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden,
            bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
        </PublicDocument>
      </AppPublicPage>
    </AppPublicLayout>
  );
}

export default Agb;
